import { render, staticRenderFns } from "./DistributionItem.vue?vue&type=template&id=62b7a942&"
import script from "./DistributionItem.vue?vue&type=script&lang=js&"
export * from "./DistributionItem.vue?vue&type=script&lang=js&"
import style0 from "./DistributionItem.vue?vue&type=style&index=0&id=62b7a942&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports